<template>
  <centered-layout>
    <div class="text-center">
      <h1 class="title mb-4">Please sign in to continue</h1>
      <v-btn size="medium" color="primary"
             depressed @click="handleAuth">Sign in</v-btn>
    </div>
  </centered-layout>
</template>

<script>
import CenteredLayout from './layouts/CenteredLayout.vue';
import AuthService from '../auth/service';

import { BASE_URL } from '../auth/config';

import { stripTrailingSlash } from '../helpers/strings';
import { buildPathUrl } from '../helpers/http';

export default {
  methods: {
    buildRedirectUrl() {
      const { origin } = window.location;
      const { from } = this.$route.params;

      let path = stripTrailingSlash(BASE_URL);

      if (from) {
        const { fullPath } = from;

        path += fullPath;
      }

      return buildPathUrl(path, origin);
    },
    handleAuth() {
      const redirect = this.buildRedirectUrl();

      AuthService.proceedToSignIn(redirect);
    },
  },
  components: { CenteredLayout },
};
</script>
